// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Dnb","question":"e_Enb","button":"e_Fnb","buttonNegative":"e_Gnb","buttonPositive":"e_Hnb","icon":"e_Inb","iconNegative":"e_Jnb","iconPositive":"e_Knb"};